import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useState } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import Header from './Header';
import Menu from './CommonMenu';
import TrangPageApi from './TrangPageApi';
import { FILE_URL } from './Constants';
import logoSmall from "./Theme/img/linhqquylogo-small.jpg";
import $ from 'jquery';
window.jQuery = $;
require('textillate');


function TrangPage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('id');
  const [data, setData] = useState(null);

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: { effect: 'fadeIn', delayScale: 3, shuffle: false },
      out: { effect: 'fadeOut', delayScale: 1.5, delay: 100, sync: false, shuffle: false, reverse: false }
    });

    $("#sky-bg").fadeIn(2e3);

    if (postId) {
        TrangPageApi.getDataByPostId(postId).then((res) => {
            if (Array.isArray(res) && res.length > 0) {
                setData(res[0]);
            } else {
                setData(res);
            }
        });
    }

  }, [postId, slug]);

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>{data?.Title || "Trang"} | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />

      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />

      <section>
        <div className="container contentContainer">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <Menu value={"home"} />
              {data ? (
                <div className="dynamic-page-content" style={{ marginTop: '20px', padding: '20px', background: '#fff', borderRadius: '8px' }}>
                  <h1 style={{ color: '#80271A', borderBottom: '2px solid #FFD21D', paddingBottom: '10px' }}>{data.Title}</h1>
                  {data.Thumb && (
                    <div style={{ textAlign: 'center', margin: '20px 0' }}>
                      <img src={FILE_URL + data.Thumb} alt={data.Title} style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }} />
                    </div>
                  )}
                  <div 
                    className="content-body" 
                    dangerouslySetInnerHTML={{ __html: data.Content || data.description }} 
                    style={{ fontSize: '1.6rem', lineHeight: '1.8', color: '#333' }}
                  />
                </div>
              ) : (
                <div style={{ padding: '50px', textAlign: 'center' }}>
                  <h3>Đang tải nội dung...</h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="footer-copyright">
        <div className="container">
          <div className="row">
             <div className="col-md-1">
               <img className="img-responsive" src={logoSmall} alt="Logo" />
             </div>
             <div className="col-md-5">
               Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
             </div>
             <div className="col-md-6">
               Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
             </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TrangPage;
